<set-css *ngIf="config" [theme]="config.theme"></set-css>
<ng-container >
  <link *ngFor="let style of styles" rel="stylesheet" type="text/css" [attr.href]="style">
</ng-container>

<ng-container *ngFor="let slideInfo of slides">
  <div
    class="fixed presenter_content"
    id="slide-{{slideInfo.order}}"
    *ngIf="slideInfo.slide.loaded"
    [ngClass]="{
      'current': slideInfo.order === currentSlide,
      'previous': slideInfo.order === previousSlide,
      'visible': slideInfo.order === currentSlide,
      'hide': slideInfo.order !== currentSlide && slideInfo.order === previousSlide,
      'hidden': slideInfo.order !== currentSlide && slideInfo.order !== previousSlide}"
    [ngStyle]="{
      'animation-name': getAnimationName(slideInfo),
      'animation-duration': slideInfo.animation.duration,
      'animation-direction': getAnimationDirection(slideInfo),
      'animation-fill-mode': 'forwards'
    }">
    <div class="inner_content justified" [innerHTML]="slideInfo.slide.content"></div>
  </div>
</ng-container>

<div id="presenter_footer" class="container-fluid presenter_footer" *ngIf="config" (window:keyup)="onKeyup($event)">
  <div class="row">
    <div class="col-5">{{config.title}}</div>
    <div class="col-5">{{config.author}}</div>
    <div class="col-2" style="text-align: right;"><span (click)="onClose()">X</span></div>
  </div>
</div>

<!-- <div style="text-align: center" >
  <span (click)="onPrevSlide()">&lt;</span>
  <span (click)="onNextSlide()">&gt;</span>
</div> -->
